import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "~/components/Button";
import { Modal } from "~/components/Modal";

type Props = {
	visible: boolean;
};

export const RequestModal: React.FC<Props> = ({ visible }) => {
	const navigate = useNavigate();

	const handleNavigateOut = useCallback(() => {
		navigate("/", { replace: true });
	}, [navigate]);

	return (
		<Modal visible={visible}>
			<div className="flex flex-col gap-4 items-center justify-center">
				<h3 className="text-xl">Sucesso</h3>
				<p className="my-5">
					Plano assinado com sucesso. Acompanhe seu e-mail para confirmar o
					status de pagamento.
				</p>
				<Button onClick={handleNavigateOut}>Entendido</Button>
			</div>
		</Modal>
	);
};
